// extracted by mini-css-extract-plugin
module.exports =  {"sortableItem":"style-module_sortableItem__YFs1oCIFjeEqr7WZDYWe","name":"style-module_name__WgLW2Nm7Iyy3U8f6iI_y"};